import React, { useContext, useEffect, useState } from "react";
import { Grid, Typography } from "@mui/material";
import palette from "../../../styles/palette";
import { GlobalContext } from "../../../context/GlobalContext";
import { getContrastTextColor } from "../../../utils/colorManager";

interface CardFooterRowProps {
  item: any;
  rowHeight?: number;
  typographyVariant?: any;
  lastItemTypographyVariant?: any;
}

const CardFooterRow: React.FC<CardFooterRowProps> = ({
  item,
  rowHeight = 30,
  typographyVariant = "t4",
  lastItemTypographyVariant = "b7",
}) => {
  const { theme } = useContext(GlobalContext);
  const [backgroundColor, setBackgroundColor] = useState("");
  useEffect(() => {
    if (theme?.secondaryColor) setBackgroundColor(theme?.secondaryColor);
  }, [theme?.secondaryColor]);

  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      sx={{
        color: palette.black,
        height: rowHeight,
      }}
    >
      <Typography
        variant={item.lastItem ? lastItemTypographyVariant : typographyVariant}
      >
        {item.name}
      </Typography>
      <Typography
        variant={item.lastItem ? lastItemTypographyVariant : typographyVariant}
        sx={{ fontWeight: 700 }}
      >
        {item.value}
      </Typography>
    </Grid>
  );
};

export default CardFooterRow;
